export default __webpack_public_path__ + "static/media/q1_step2_1.c3d07788.png";